import axios, { ResponseType } from "axios";

import { FileMimeTypes } from "./Types";

//временная мера, но самому прописывать импорт это анрил
export const FILES_SERVICE = {
  async getFileById(id: number, type: ResponseType = "arraybuffer") {
    const { data } = await axios.get(`/File/Download?id=${id}`, {
      responseType: type,
    });
    const url = URL.createObjectURL(data);
    return url;
  },
};

export default {
  getFileById(id: number, type: ResponseType = "arraybuffer") {
    return axios.get(`/File/Download?id=${id}`, {
      responseType: type,
    });
  },
  getFileByGuid(guid) {
    return axios.get(`/File/DownloadGuid?guid=${guid}`, {
      responseType: "blob",
    });
  },
  getFullFileByGuid(guid) {
    return axios.get(`/File/GetFile?guid=${guid}`, {});
  },
  async getTransformFileByGuid(guid) {
    const { data } = await axios.get(`/File/DownloadGuid?guid=${guid}`, {
      responseType: "blob",
    });

    const url = URL.createObjectURL(data);
    return url;
  },
};

export const getFileMimeType = (type: string): FileMimeTypes => {
  const IMAGE_TYPES = ["image/gif", "image/jpeg", "image/png"];
  const DOC_TYPES = [
    "doc",
    ".docx",
    "application/doc",
    "application/ms-doc",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const XLS_TYPES = [
    "application/excel",
    "application/vnd.ms-excel",
    "application/x-excel",
    "application/x-msexcel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const PDF_TYPES = ["application/pdf"];

  if (IMAGE_TYPES.includes(type)) {
    return FileMimeTypes.img;
  }
  if (DOC_TYPES.includes(type)) {
    return FileMimeTypes.doc;
  }
  if (XLS_TYPES.includes(type)) {
    return FileMimeTypes.xls;
  }
  if (PDF_TYPES.includes(type)) {
    return FileMimeTypes.pdf;
  }
  return FileMimeTypes.none;
};
